import React, { useContext, useState, useEffect } from 'react'
import { styled } from 'linaria/react'
import { ProductAccordion } from './ProductAccordion'
import { ChatBubbleQuestion, NavArrowRight, Cancel } from 'iconoir-react'
import { SiteContext } from '../../Global/SiteContext'
import { theme } from '../../Theme'
import SiteButton from '../../Core/SiteButton'
import { useIntl } from '@jetshop/intl'
import ChannelContext from '@jetshop/core/components/ChannelContext/ChannelContext'
import ProductQuestionItem from './ProductQuestionItem'
import { fetchProductReviews } from '../../TestFreaks/Api'
import ProductQuestionForm from './ProductQuestionForm'
import { getHostname } from '../../Core/Util/Helpers'

const QuestionsTopContent = styled.div`
   display: flex;
   background-color: #ffffff;
   margin-bottom: 1rem;
`

const removeUnansweredQuestions = questions => {
   if (!Array.isArray(questions)) {
      return []
   }
   const filteredQuestions = questions.filter(question => {
      return (
         Array.isArray(question?.responses) && question?.responses.length > 0
         // Further checks, iteratetion, not just index 0 ?
         // &&
         // typeof question?.responses[0]?.response === 'string' &&
         // question?.responses[0]?.response.trim() !== ''
      )
   })
   return filteredQuestions
}

const ProductQuestions = () => {
   const { productReviews, activeVariant } = useContext(SiteContext)
   const [page, setPage] = useState(1)
   const [hasNextPage, setHasNextPage] = useState(false)
   const selectedChannel = useContext(ChannelContext)?.selectedChannel
   const [questions, setQuestions] = useState([])
   const t = useIntl()
   const [showSendQuestion, setShowSendQuestion] = useState(false)

   useEffect(() => {
      const questions = productReviews?.questions ?? []
      const questionCount = productReviews?.summary?.your_question_count ?? 0

      if (questions.length > 0) {
         setShowSendQuestion(false)
         setQuestions(questions)
         setHasNextPage(questionCount > questions.length)
      } else {
         setQuestions([])
         setShowSendQuestion(true)
      }
   }, [productReviews, activeVariant?.articleNumber])

   
    
   const loadMoreQuestions = async () => {
      const response = await fetchProductReviews(
        activeVariant?.articleNumber ?? '',
        10,
        page + 1,
        getHostname(selectedChannel?.url, 'verktygsboden.se')
      );
    
      const updatedQuestions = [
        ...(questions ?? []),  
        ...(response?.questions ?? [])
      ];
    
      setQuestions(updatedQuestions);
      const totalQuestions = response?.summary?.your_question_count ?? 0;
      setHasNextPage(totalQuestions > updatedQuestions.length);
      setPage((prev) => prev + 1);
    };
    

   return (
      <section id="product-questions">
         <ProductAccordion
            title={`${t('questions and answers')}`}
            // subTitle={`(${questions?.length ?? 0} ${
            //    questions?.length == 1 ? t('question') : t('questions')
            // })`}
            subTitle={`(${productReviews?.summary?.your_question_count ?? 0} ${`st`})`}
            icon={
               <ChatBubbleQuestion
                  width="1.8rem"
                  height="1.8rem"
                  strokeWidth={2.5}
               ></ChatBubbleQuestion>
            }
         >
            {questions && questions?.length > 0 && (
               <QuestionsTopContent>
                  <SiteButton
                     size="medium"
                     onClick={() => setShowSendQuestion(prev => !prev)}
                     styleType="solid"
                     color={'blue'}
                     className="py-8 px-16"
                  >
                     {showSendQuestion ? t('close form') : t('ask a question')}
                     {showSendQuestion ? (
                        <Cancel
                           strokeWidth={2.0}
                           style={{ marginLeft: '1rem' }}
                        ></Cancel>
                     ) : (
                        <NavArrowRight
                           strokeWidth={2.0}
                           style={{ marginLeft: '1rem' }}
                        ></NavArrowRight>
                     )}
                  </SiteButton>
               </QuestionsTopContent>
            )}

            {!showSendQuestion ? (
               <div className="product-questions-list my-16">
                  <div>
                     {questions?.map((question, i) => {
                        return (
                           <ProductQuestionItem
                              key={i}
                              question={question}
                           ></ProductQuestionItem>
                        )
                     })}
                     <SiteButton
                        style={{ padding: '0.8rem 0.8rem 0.8rem 1.5rem' }}
                        onClick={() => loadMoreQuestions()}
                        disabled={!hasNextPage}
                        styleType="solid"
                        color="blue"
                        size="medium"
                        icon={true}
                     >
                        {t('load more questions and answers')}
                        <NavArrowRight
                           strokeWidth={2.0}
                           style={{ marginLeft: '1rem' }}
                        ></NavArrowRight>
                     </SiteButton>
                  </div>
               </div>
            ) : (
               <ProductQuestionForm
                  activeVariant={activeVariant}
                  className="my-16"
               />
            )}
         </ProductAccordion>
      </section>
   )
}

export default ProductQuestions
